import ESTIMATE_CONSTANT from "../../constant/estimateConstant"
import type EstimateValues from "../../types/params"
import getConstantByValue from "../constant/getConstantByValue"
import getNumberOfLayers from "../getNumberOfLayers"

const resolveSilkPrintSideName = (value: string, { layer }: Pick<EstimateValues, "layer">) => {
  const numberOfLayers = getNumberOfLayers({ layer })
  const isOneLayer = numberOfLayers === 1

  switch (value) {
    case ESTIMATE_CONSTANT.印刷する面["パターン面と同じ面(L1面)"].value:
      return isOneLayer ? "パターン面と同じ面" : "L1面"
    case ESTIMATE_CONSTANT.印刷する面["パターン面とは逆の面(Ln面)"].value:
      return isOneLayer ? "パターン面とは逆の面" : `L${numberOfLayers}面`
    default:
      return getConstantByValue("silk", value).name
  }
}

export default resolveSilkPrintSideName
